import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "aepbuttonstyle"
    }}>{`AepButtonStyle`}</h1>
    <p>{`Class representing the style of an AepButton composable.`}</p>
    <h2 {...{
      "id": "public-properties"
    }}>{`Public Properties`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`modifier`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://developer.android.com/reference/kotlin/androidx/compose/ui/Modifier"
            }}>{`Modifier`}</a>{`?`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The modifier to be applied to the button.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`enabled`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Boolean?`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The enabled state of the button.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`elevation`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://developer.android.com/reference/kotlin/androidx/compose/material3/ButtonElevation?hl=en"
            }}>{`ButtonElevation`}</a>{`?`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The elevation of the button.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`shape`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://developer.android.com/reference/kotlin/androidx/compose/ui/graphics/Shape?hl=en"
            }}>{`Shape`}</a>{`?`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The shape of the button.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`border`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://developer.android.com/reference/kotlin/androidx/compose/foundation/BorderStroke?hl=en"
            }}>{`BorderStroke`}</a>{`?`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The border to draw around the container of this button.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`colors`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://developer.android.com/reference/kotlin/androidx/compose/material3/ButtonColors?hl=en"
            }}>{`ButtonColors`}</a>{`?`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The colors that will be used for this button in different states.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`contentPadding`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://developer.android.com/reference/kotlin/androidx/compose/foundation/layout/PaddingValues?hl=en"
            }}>{`PaddingValues`}</a>{`?`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The spacing values to apply internally between the container and the text.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      